import { environmentHttpClient, HttpClient } from "client/Api/httpClient";

export type CultureId =
	| "en"
	| "en-AU"
	| "en-GB"
	| "en-NZ"
	| "nl"
	| "da"
	| "nb"
	| "it"
	| "sv"
	| "es"
	| "de"
	| "fr";

export type CultureModel = {
	id: CultureId;
	name: string;
};

export type UserCultureResult = {
		userCultureDetermined: false;
	}
	|
	{
		userCultureDetermined: true;
		userCulture: string;
	};

export function setUserCulture(
	culture: string,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UserCulture",
		culture,
		{signal}
	);
};

export function getUserCulture(
	signal?: AbortSignal
): Promise<UserCultureResult> {
	return environmentHttpClient.get<UserCultureResult>(
		"/UserCulture",
		undefined,
		{signal}
	);
};

export function listApplicationCultures(
	signal?: AbortSignal
): Promise<readonly CultureModel[]> {
	const httpclient = new HttpClient();

	return httpclient.get<readonly CultureModel[]>(
		"/ApplicationCulture",
		undefined,
		{signal}
	);
}
